

export const EOL = "\r\n";